import { TinyMCEEvent } from './event.interface';
import { isTokenElement } from '../utils';

const REMOVE_COMMANDS = 'RemoveFormat';

export const isRemoveFormatEvent = (element: HTMLElement, event: TinyMCEEvent): boolean => {
  return isTokenElement(element) && event.command === REMOVE_COMMANDS;
};
